<div class="echartsHeatmapWrapper">
  <div #heatmapContainer class="echartsHeatmapContainer"
    [style.height.px]="passedHeight"
    [class.dimmed]="noDataOnChart"></div>
  @if (noDataOnChart) {
    <div class="noDataOverlay secondaryTextColor">
      {{ 'STATISTICS.NO_CHART_DATA' | translate }}
    </div>
  }
</div>
